/**
 * Merging the private overlay onto the public view.
 *
 * Its own module, with no browser or network imports, so the one piece of logic
 * a client can most easily get wrong is testable in isolation.
 */

export interface ZoneView {
  cards?: string[];
  count?: number;
  partial?: boolean;
}

/** A game-specific view. Everything but `zones` is passed through untouched. */
export interface GameView {
  zones?: Record<string, ZoneView>;
  [key: string]: unknown;
}

/**
 * Merge the private overlay onto the public view.
 *
 * Zones merge **key by key**; every other field is replaced if present. A zone
 * the seat sees more of wins, and every zone it does not appears exactly as the
 * table shows it.
 *
 * Replacing the whole zones map instead is the tempting one-liner, and it
 * blanks every other player's card count - because the personal section carries
 * only the zones this seat sees beyond the public view, by design.
 */
export function mergeView(table: GameView, personal: GameView | null): GameView {
  if (!personal) return table;

  const merged: GameView = { ...table, ...personal };
  if (table.zones || personal.zones) {
    merged.zones = { ...(table.zones ?? {}), ...(personal.zones ?? {}) };
  }
  return merged;
}
